import { useSuspenseInfiniteQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { GetNotificationsOptions, NotificationResponse } from 'src/shared/schemas/stream/notification'

const getNotifications = async (options?: GetNotificationsOptions) => {
  try {
    const queryParams = new URLSearchParams()
    if (options?.offset !== undefined) queryParams.append('offset', options.offset.toString())
    if (options?.limit !== undefined) queryParams.append('limit', options.limit.toString())

    const response = await getRequest<NotificationResponse>(`/feeds/notifications/list?${queryParams.toString()}`)
    if (!response) {
      return null
    }
    return response
  } catch (error) {
    console.error(`Failed to fetch notifications | ${error}`)
    return null
  }
}

export const useGetNotifications = (options?: Omit<GetNotificationsOptions, 'offset'>) => {
  return useSuspenseInfiniteQuery({
    ...queries.notifications.list(options),
    queryFn: ({ pageParam = 0 }) => {
      return getNotifications({
        limit: options?.limit || 10,
        offset: pageParam,
      })
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      if (!lastPage?.hasNext) return undefined
      return lastPage.nextOffset
    },
    staleTime: 1000 * 60,
    retry: 1,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  })
}
